import mock from '../mock'
/*eslint-disable */
const previousDay = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
const dayBeforePreviousDay = new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 2)

const data = {
  profileUser: {
    id: 11,
    avatar: require('@src/assets/images/portrait/small/avatar-s-8.jpg').default,
    fullName: 'Nguyễn Văn Minh',
    role: 'Quản trị viên IOC',
    about:
      'Phụ trách vận hành và giám sát hệ thống Trung tâm Điều hành Thành phố thông minh (IOC). Tổng hợp và phân tích các chỉ tiêu IOC trên các lĩnh vực.',
    status: 'online',
    settings: {
      isTwoStepAuthVerificationEnabled: true,
      isNotificationsOn: false
    }
  },
  contacts: [
    {
      id: 1,
      fullName: 'Trần Thị Mai',
      role: 'Chuyên viên Dân số & Dân cư',
      about: 'Quản lý dữ liệu dân số, theo dõi tỷ lệ tăng dân số, mật độ dân cư và các chỉ tiêu dân cư phường/xã.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-2.jpg').default,
      status: 'offline'
    },
    {
      id: 2,
      fullName: 'Lê Văn Hùng',
      role: 'Chuyên viên Kinh tế địa phương',
      about:
        'Theo dõi số lượng doanh nghiệp, chỉ số kinh doanh, thu nhập bình quân đầu người và các chỉ tiêu phát triển kinh tế địa phương.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-1.jpg').default,
      status: 'busy'
    },
    {
      id: 3,
      fullName: 'Phạm Thị Lan',
      role: 'Chuyên viên Y tế cộng đồng',
      about:
        'Giám sát tỷ lệ bao phủ bảo hiểm y tế, tình hình bệnh truyền nhiễm, số lượng cơ sở y tế và các chỉ tiêu sức khỏe cộng đồng.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-3.jpg').default,
      status: 'busy'
    },
    {
      id: 4,
      fullName: 'Nguyễn Thị Hoa',
      role: 'Chuyên viên Giáo dục & Thanh thiếu niên',
      about:
        'Quản lý chỉ tiêu tỷ lệ nhập học, số lượng trường học, tỷ lệ học sinh tốt nghiệp và các chỉ số giáo dục địa phương.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-4.jpg').default,
      status: 'online'
    },
    {
      id: 5,
      fullName: 'Hoàng Văn Nam',
      role: 'Chuyên viên An ninh – Trật tự xã hội',
      about: 'Theo dõi tỷ lệ tội phạm, số vụ vi phạm trật tự, thời gian phản hồi của lực lượng an ninh.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-5.jpg').default,
      status: 'busy'
    },
    {
      id: 6,
      fullName: 'Đỗ Thị Thu',
      role: 'Chuyên viên Môi trường & Chất lượng sống',
      about:
        'Giám sát chỉ số chất lượng không khí (AQI), tỷ lệ thu gom rác thải, chất lượng nước và các chỉ tiêu môi trường đô thị.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-6.jpg').default,
      status: 'online'
    },
    {
      id: 7,
      fullName: 'Vũ Văn Thành',
      role: 'Chuyên viên Giao thông thông minh',
      about:
        'Theo dõi lưu lượng giao thông, mức độ ùn tắc, số vụ tai nạn và hiệu quả hoạt động của hệ thống giao thông thông minh.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-7.jpg').default,
      status: 'online'
    },
    {
      id: 8,
      fullName: 'Bùi Thị Thúy',
      role: 'Chuyên viên Ngân sách & Tài chính',
      about:
        'Quản lý dự toán thu chi ngân sách, tỷ lệ giải ngân, nợ công địa phương và các chỉ tiêu tài chính công.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-8.jpg').default,
      status: 'away'
    },
    {
      id: 9,
      fullName: 'Đinh Văn Tú',
      role: 'Chuyên viên Quy hoạch & Phát triển đô thị',
      about:
        'Theo dõi số dự án đang triển khai, tiến độ dự án, chỉ tiêu phát triển hạ tầng đô thị và quy hoạch sử dụng đất.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-9.jpg').default,
      status: 'offline'
    },
    {
      id: 10,
      fullName: 'Lý Thị Hồng',
      role: 'Chuyên viên Du lịch – Văn hoá – Thể thao',
      about: 'Giám sát lượng khách du lịch, doanh thu du lịch, số sự kiện văn hóa và các chỉ tiêu du lịch địa phương.',
      avatar: require('@src/assets/images/portrait/small/avatar-s-10.jpg').default,
      status: 'away'
    }
  ],
  chats: [
    {
      id: 1,
      userId: 1,
      unseenMsgs: 0,
      chat: [
        {
          message: 'Chào chị Mai, anh cần kiểm tra lại số liệu tổng dân số phường tháng này.',
          time: 'Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Chào anh Minh! Theo số liệu mới nhất, tổng dân số phường hiện là 24.350 người.',
          time: 'Mon Dec 10 2018 07:45:15 GMT+0000 (GMT)',
          senderId: 1
        },
        {
          message: 'Tỷ lệ tăng dân số so với tháng trước như thế nào chị?',
          time: 'Mon Dec 10 2018 07:46:10 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Tỷ lệ tăng dân số tháng này là 0,12%, chủ yếu do dân nhập cư tăng.',
          time: 'Mon Dec 10 2018 07:46:30 GMT+0000 (GMT)',
          senderId: 1
        },
        {
          message: 'Số hộ gia đình và mật độ dân số/km² có thể cập nhật lên dashboard IOC không chị?',
          time: 'Mon Dec 10 2018 07:47:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Em đang tổng hợp, sẽ cập nhật trước 15h hôm nay. Mật độ dân số hiện khoảng 8.200 người/km².',
          time: dayBeforePreviousDay,
          senderId: 1
        }
      ]
    },
    {
      id: 2,
      userId: 2,
      unseenMsgs: 1,
      chat: [
        {
          message: 'Anh Hùng ơi, số liệu doanh nghiệp thành lập mới tháng này đã cập nhật chưa?',
          time: 'Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Anh Minh, tháng này có 47 doanh nghiệp thành lập mới, tăng 12% so với cùng kỳ năm ngoái.',
          time: 'Mon Dec 10 2018 07:45:23 GMT+0000 (GMT)',
          senderId: 2
        },
        {
          message: 'Còn số doanh nghiệp ngừng hoạt động thì sao?',
          time: 'Mon Dec 10 2018 07:45:55 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Có 8 doanh nghiệp ngừng hoạt động, thấp hơn so với trung bình 6 tháng đầu năm.',
          time: 'Mon Dec 10 2018 07:46:00 GMT+0000 (GMT)',
          senderId: 2
        },
        {
          message: 'Thu nhập bình quân đầu người quý này có số liệu chưa anh?',
          time: 'Mon Dec 10 2018 07:46:20 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Dữ liệu sơ bộ cho thấy thu nhập bình quân đạt khoảng 6,8 triệu đồng/người/tháng.',
          time: 'Mon Dec 10 2018 07:46:35 GMT+0000 (GMT)',
          senderId: 2
        },
        {
          message: 'Tốt! Anh đẩy số liệu lên hệ thống IOC trước cuối giờ hành chính nhé.',
          time: 'Mon Dec 10 2018 07:46:50 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Vâng, em sẽ cập nhật ngay. Anh nhớ kiểm tra lại chỉ tiêu tỷ lệ thất nghiệp nữa nhé.',
          time: previousDay,
          senderId: 2
        }
      ]
    },
    {
      id: 3,
      userId: 3,
      unseenMsgs: 2,
      chat: [
        {
          message: 'Chị Lan, tình hình bao phủ bảo hiểm y tế tháng này ra sao?',
          time: 'Mon Dec 11 2018 08:00:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Tỷ lệ bao phủ BHYT hiện đạt 92,5% dân số, tăng 1,2% so với quý trước.',
          time: 'Mon Dec 11 2018 08:05:00 GMT+0000 (GMT)',
          senderId: 3
        },
        {
          message: 'Có ca bệnh truyền nhiễm nào đáng lo ngại không chị?',
          time: 'Mon Dec 11 2018 08:10:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Tuần này ghi nhận 3 ca sốt xuất huyết mới, đang theo dõi sát. Chưa có dấu hiệu bùng phát.',
          time: 'Mon Dec 11 2018 08:12:00 GMT+0000 (GMT)',
          senderId: 3
        },
        {
          message: 'Nhớ cập nhật lên bảng cảnh báo IOC ngay nhé chị, để ban lãnh đạo theo dõi kịp thời.',
          time: dayBeforePreviousDay,
          senderId: 11
        }
      ]
    },
    {
      id: 6,
      userId: 6,
      unseenMsgs: 0,
      chat: [
        {
          message: 'Chị Thu ơi, chỉ số AQI hôm nay ở mức nào vậy?',
          time: 'Mon Dec 12 2018 09:00:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'AQI đo được lúc 8h sáng là 87, ở mức trung bình, không có cảnh báo đặc biệt.',
          time: 'Mon Dec 12 2018 09:05:00 GMT+0000 (GMT)',
          senderId: 6
        },
        {
          message: 'Tỷ lệ thu gom rác thải tuần này thế nào?',
          time: 'Mon Dec 12 2018 09:10:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Đạt 98,3%, còn 1,7% ở các khu vực ngõ hẻm chưa tiếp cận được xe thu gom lớn.',
          time: 'Mon Dec 12 2018 09:12:00 GMT+0000 (GMT)',
          senderId: 6
        },
        {
          message: 'Tốt! Anh sẽ đưa số liệu này vào báo cáo IOC tuần. Chị nhớ theo dõi thêm chỉ tiêu chất lượng nước nhé.',
          time: previousDay,
          senderId: 11
        }
      ]
    },
    {
      id: 7,
      userId: 7,
      unseenMsgs: 3,
      chat: [
        {
          message: 'Anh Thành, hệ thống camera giao thông có phát hiện điểm ùn tắc mới không?',
          time: 'Mon Dec 13 2018 07:30:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Sáng nay ghi nhận ùn tắc nhẹ tại nút giao đường Nguyễn Trãi - Lê Văn Lương vào giờ cao điểm.',
          time: 'Mon Dec 13 2018 07:35:00 GMT+0000 (GMT)',
          senderId: 7
        },
        {
          message: 'Thời gian di chuyển trung bình tuyến trục chính tăng bao nhiêu % so với hôm qua?',
          time: 'Mon Dec 13 2018 07:40:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Tăng khoảng 15% so với hôm qua, chủ yếu do công trình sửa chữa hạ tầng đoạn km 3+200.',
          time: 'Mon Dec 13 2018 07:42:00 GMT+0000 (GMT)',
          senderId: 7
        },
        {
          message: 'Anh cập nhật số liệu tai nạn giao thông tuần này lên IOC nhé, đặc biệt các điểm đen mới phát sinh.',
          time: 'Mon Dec 13 2018 07:45:00 GMT+0000 (GMT)',
          senderId: 11
        },
        {
          message: 'Vâng anh, tuần này không có tai nạn nghiêm trọng, chỉ có 2 vụ va chạm nhỏ. Em sẽ cập nhật ngay.',
          time: previousDay,
          senderId: 7
        }
      ]
    }
  ]
}
/*eslint-enable */
// ------------------------------------------------
// GET: Return Chats Contacts and Contacts
// ------------------------------------------------
mock.onGet('/apps/chat/chats-and-contacts').reply(() => {
  const chatsContacts = data.chats.map(chat => {
    const contact = data.contacts.find(c => c.id === chat.userId)
    contact.chat = { id: chat.id, unseenMsgs: chat.unseenMsgs, lastMessage: chat.chat[chat.chat.length - 1] }
    return contact
  })
  const profileUserData = {
    id: data.profileUser.id,
    avatar: data.profileUser.avatar,
    fullName: data.profileUser.fullName,
    status: data.profileUser.status
  }
  return [200, { chatsContacts, contacts: data.contacts, profileUser: profileUserData }]
})

// ------------------------------------------------
// GET: Return User Profile
// ------------------------------------------------
mock.onGet('/apps/chat/users/profile-user').reply(() => [200, data.profileUser])

// ------------------------------------------------
// GET: Return Single Chat
// ------------------------------------------------
mock.onGet('/apps/chat/get-chat').reply(config => {
  // Get event id from URL

  let userId = config.id

  //  Convert Id to number
  userId = Number(userId)

  const chat = data.chats.find(c => c.id === userId)
  if (chat) chat.unseenMsgs = 0
  const contact = data.contacts.find(c => c.id === userId)
  if (contact.chat) contact.chat.unseenMsgs = 0
  return [200, { chat, contact }]
})

// ------------------------------------------------
// POST: Add new chat message
// ------------------------------------------------
mock.onPost('/apps/chat/send-msg').reply(config => {
  // Get event from post data
  const { obj } = JSON.parse(config.data)

  let activeChat = data.chats.find(chat => chat.userId === obj.contact.id)

  const newMessageData = {
    message: obj.message,
    time: new Date(),
    senderId: 11
  }
  // If there's new chat for user create one
  let isNewChat = false
  if (activeChat === undefined) {
    isNewChat = true

    const { length } = data.chats
    // const lastId = data.chats[length - 1].id

    data.chats.push({
      id: obj.contact.id,
      userId: obj.contact.id,
      unseenMsgs: 0,
      chat: [newMessageData]
    })
    activeChat = data.chats[data.chats.length - 1]
  } else {
    activeChat.chat.push(newMessageData)
  }

  const response = { newMessageData, id: obj.contact.id }
  if (isNewChat) response.chat = activeChat

  return [201, { response }]
})
